export default {
    title: 'New Referral',
    breadcrumbs: {
        search: 'Match criteria',
        results: 'Results',
        schedule: 'Schedule',
        make: 'Request appointment',
    },
    steps: {
        search: {
            heading: 'Match referral',
            description: 'Choose the criteria for your referral',
        },
        results: {
            heading: {
                physician:
                    'There are no MedMatch Network providers | There is 1 MedMatch Network provider | There are {count} MedMatch Network providers',
                ancillary:
                    'There are no MedMatch Network providers | There is 1 MedMatch Network provider | There are {count} MedMatch Network providers',
                physician_feasibility: 'No providers found | 1 provider found | {count} providers found',
                ancillary_feasibility: 'No providers found | 1 provider found | {count} providers found',
                network:
                    'There are no providers from your Network | and 1 of them is from your Network | and {count} of them are from your Network',
            },
            preselect: {
                desktop: 'Clear all and custom selection ({count} selected)',
                mobile: 'Clear all & custom select ({count})',
            },
            searching: 'Searching for providers…',
            search_error_heading: 'Search failed',
            search_error: 'The search could not be completed.',
            search_error_link: 'Try with other search criteria',
            view_map: 'View on map',
            view_more: 'View more',
            range: {
                label: 'Within:',
                miles: '1 mile | {n} miles',
            },
            blank_slate: {
                message: 'Try',
                link: ' with other search criteria',
            },
            physicians_not_in_medmatch: 'Providers not on MedMatch Network - Insurance accepted not known',
            physicians_not_in_medmatch_feasibility: 'Providers not on MedMatch - Insurance accepted not known',
        },
        schedule: {
            heading: {
                physician: 'Request an appointment with {name}',
                ancillary: 'Request an appointment at {name}',
            },
            slots_available: '1 slot available | {n} slots available',
            not_available: 'No Slots Available!',
            referrals: '1 referral | {n} referrals',
            request_slot: 'Request slot',
            confirm_slot: 'Confirm slot',
            select_slot: 'Select',
            am: 'AM',
            pm: 'PM',
            warning_24h: {
                heading: 'Appointments that fall within 24 hours, must be reported to referring provider, to ensure availability',
                please_call: 'Please call {physician} directly:',
                done: 'Done',
                continue: 'Continue',
            },
        },
        confirmation: {
            request_sent: 'Request sent!',
            selection_sent: 'Selection sent!',
            heading: 'Your request has been successfully sent',
            time_slots_proposed: 'Please hold these time slots. We are contacting patient/provider to confirm referral.',
            heading_pool: 'Your confirmation has been sent',
            view_referral: 'View referral',
            summary: {
                patient_name: 'Patient name',
                diagnosis: 'Diagnosis',
                to: 'To',
                print: 'Print',
                tel: 'Tel. {phone}',
            },
        },
    },
    microcopy: {
        back_to_results: '← Back to results',
        today: 'Today',
        slots: '1 slot | {n} slots',
        referrals: '1 referral | {n} referrals',
    },

    dropdown: {
        label: {
            view_details: 'View Details',
            print_prescription: 'Print Prescription',
            follow_up_visit: 'Follow Up Visit',
            view_referral: 'View Referral',
            patient_visit: 'Visit Patient Profile',
            referred: {
                cancel: 'Cancel Appointment',
                reschedule: 'Reschedule Appointment',
                show_status: 'Show Status',
                confirm: 'Confirm Appointment',
                decline: 'Decline Appointment',
                patient_seen: 'Update Patient Visit Status',
                add_report: 'Add Report',
                propose_slot: 'Propose Slot',
                request_additional_records: 'Request Additional Records',
                additional_records: 'Additional Records',
            },
            referring: {
                cancel: 'Cancel Referral',
                match: 'Match Referral',
                request_report: 'Request Report',
                choose_slot: 'Choose Slot',
                upload_requested_records: 'Upload Records',
            },
            set_available: 'Set Available',
            set_unavailable: 'Set Unavailable',
            create_referral: 'Create referral',
        },
    },
}
